import { isActiveRequisitionState } from "src/util/requisitionState";

/** POWER/ADMIN may close live hiring requests (not already Closed). */
export const canCloseRequisition = (
  state: string | null | undefined
): boolean => isActiveRequisitionState(state);
